import { ISelection } from './interfaces';
import { ICartState } from './stateInterface';

export default {
  CART_ADD: (state: ICartState, data: {pick: ISelection, classic: boolean}) => {
    /*if (data.classic) {
      state.classicPicks.push(data.pick)
      return
    }*/
    
    state.dailyPicks.push(data.pick)
  },
  CART_REMOVE: (state: ICartState, data: {pick: ISelection, classic: boolean}) => {
    const picks = state.dailyPicks
    //const picks = data.classic ? state.classicPicks : state.dailyPicks
    const idx = picks.findIndex((p) => p.matchupId === data.pick.matchupId)
    if (idx > -1) {
      picks.splice(idx, 1)
    }
  },
  MARK_PICK_INVALID: (state: ICartState, data: { matchups: string[], classic: boolean}) => {
    const picks = state.dailyPicks
    //const picks = data.classic ? state.classicPicks : state.dailyPicks

    data.matchups.forEach((mu: string) => {
      const idx = picks.findIndex((p) => p.matchupId === mu)
      if (idx > -1) {
        picks[idx].invalid = true
      }
    })
    
  },
  CLEAR_CART: (state: ICartState, isClassic: boolean) => {
    //if (isClassic) {
      state.classicPicks = []
      //return
    //}
    state.dailyPicks = []
  }
};
